import React, { ComponentType, ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import { BrowserRouter, RouterProvider } from 'react-router-dom';
import { createBrowserRouter } from '@bloomays-lib/common.monitoring/browser';

import { NotFound, LoaderGlobal, Forbidden } from '@bloomays-lib/ui.shared';
import { Role } from '@bloomays-lib/types.shared';

import { AskMagicLink } from '../components/pages/AskMagicLink';
import { Home } from '../components/pages/Home';
import Bucket from '../components/templates/Bucket';
import JobList from '../components/pages/JobList';
import ProtectedRoute from '../auth/ProtectedRoute';
import Job from '../components/pages/Job';

const getProtectedComponent = (component: ComponentType, roles?: Role[]): React.JSX.Element => {
  return <ProtectedRoute Component={component} roles={roles} />;
};

export const getRouteConfig = () => {
  const router = createBrowserRouter([
    {
      path: '/',
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: 'sendMagicLink',
          element: <AskMagicLink />,
        },
      ],
    },
    {
      path: '/',
      element: <Bucket />,
      children: [
        {
          path: 'talentboard/jobs',
          element: getProtectedComponent(JobList, [Role.Client, Role.Admin, Role.System]),
        },
        {
          path: 'talentboard/jobs/:id',
          element: getProtectedComponent(Job, [Role.Client, Role.Admin, Role.System]),
        },
        {
          path: 'talentboard/jobs/:id/talent/:talentId',
          element: getProtectedComponent(Job, [Role.Client, Role.Admin, Role.System]),
        },
        {
          path: 'forbidden',
          element: <Forbidden />,
        },
        {
          path: '*',
          element: (
            <CenteredContainer>
              <NotFound />
            </CenteredContainer>
          ),
        },
      ],
    },
  ]);
  return router;
};

export const RouterWrapper = ({ children }: { children?: ReactNode }) => {
  return (
    <>
      <RouterProvider
        router={getRouteConfig()}
        fallbackElement={<LoaderGlobal waitingText="Chargement des routes" />}
      />
      <BrowserRouter>{children}</BrowserRouter>
    </>
  );
};

export default RouterWrapper;

const CenteredContainer = styled('div')(() => ({
  minHeight: 'calc(100vh - 80px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
}));
